import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PayoutService } from '../../_services';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject, Subscription, of } from 'rxjs';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { PayloadPayoutToConfirm } from 'src/app/_models/payoutCommerce.interface';
import { PayoutProcessCommerceMasiveConfirmService } from 'src/app/_services/payout-process-commerce-masive-confirm.service';
import { PayoutListResponse } from 'src/app/_models/massive-payout-confirmation-process';

@Component({
  selector: 'app-payoutprocesscommerceconfirm',
  templateUrl: './payoutprocesscommerceconfirm.component.html',
  styleUrls: ['./payoutprocesscommerceconfirm.component.css', '../../../assets/css/customer-list-table.css'],
  providers: [Ng4LoadingSpinnerService]
})
export class PayoutprocesscommerceconfirmComponent implements OnInit, OnDestroy {

  confirmForm: FormGroup;

  formData: FormData = new FormData();
  private payoutProcessId: string;
  private customerProcessId: string;

  isConfirmButtonActive: boolean = true;

  name: string;
  isChecked: boolean = false;

  getPayoutDetails$: Subscription;
  getPayoutStatus$: Subscription;
  bankGroupDataArr: { name: string; public_id: string;}[];

  timerId: NodeJS.Timeout;

  statusMap = {
    'COMPLETED': "El payout ha sido confirmado correctamente",
    'CONFIRMING': "Por favor, espere",
    'CONFIRMING_WITH_ERROR': "El payout ha sido confirmado con errores"
  };

  @ViewChild("modalConfirmationMessage") modalConfirmationMessage;
  modalRef: BsModalRef;

  confirmMessage: string = "";
  private mainBanks = ['md01', 'md02', 'md03', 'md04'];
  private destroy$ = new Subject<void>();

  constructor(
    private _fb: FormBuilder,
    private payoutService: PayoutService,
    private spinnerService: Ng4LoadingSpinnerService,
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute,
    private payoutMasiveConfirmService: PayoutProcessCommerceMasiveConfirmService
  ) {
    this.initialSetup();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.customerProcessId = this.route.snapshot.paramMap.get('customerID');
    this.payoutProcessId = this.route.snapshot.paramMap.get('payoutID');
    this.getPayoutDetails(this.payoutProcessId, this.customerProcessId);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
        return false;
      }
    }
    return true;
  }

  initialSetup() {
    this.confirmForm = this._fb.group({
      file_list: this._fb.array([])
    });
  }

  get file_list(): FormArray { return this.confirmForm.get('file_list') as FormArray; }

  notExistPreviousValue(arr, value): boolean {
    return !Object.values(arr).some(obj => obj["public_id"] === value);
  }

  isNotUndefinedOrNull(value, type) {
    return value !== type;
  }

  makeBankArr(arr: PayoutListResponse[]): { name: string, public_id: string }[] {
    const result: { name: string, public_id: string }[] = [];

    arr.forEach(obj => {
      const payoutInformation = { public_id: obj.public_id, banks: [] }

      obj.bank.forEach(data => {
        const {public_id, name} = data;
        payoutInformation.banks.push(public_id);
        const typeBank = public_id.slice(-4);
        result.push({
          name: this.mainBanks.includes(typeBank) ? name : 'Interbancario',
          public_id: public_id
        });
      });

    });
    return result;
  }

  filterUniqueObjectsByProperty(newArray: { name: string; public_id: string;}[]): { name: string; public_id: string;}[] {
    let bankGroupDataArr = [];
    for (const obj of newArray) {
      const value = obj.public_id;
      if (this.notExistPreviousValue(bankGroupDataArr, value) && (this.isNotUndefinedOrNull(obj.public_id, undefined) || this.isNotUndefinedOrNull(obj.name, undefined))) {
        bankGroupDataArr.push(obj);
      }
    }
    return bankGroupDataArr;
  }

  getBankGroupDataArr(payoutList: PayoutListResponse[]) {
    const newArray = this.makeBankArr(payoutList);
    const bankGroupDataArr = this.filterUniqueObjectsByProperty(newArray);
    return bankGroupDataArr;
  }

  deleteBankGroup(index: number) {
    this.file_list.removeAt(index);
  }

  addBankGroup(bank: any) {
    this.file_list.push(this._fb.group({
      name: new FormControl(bank.name, [Validators.required, Validators.minLength(1)]),
      label: new FormControl(''),
      url: new FormControl(''),
      pspValue: new FormControl('', [Validators.required]),
      psp: new FormControl(bank.public_id),
    }));
  }

  buildCustomConfirmForm(payoutList: PayoutListResponse[]) {
    this.bankGroupDataArr = this.getBankGroupDataArr(payoutList);
    this.bankGroupDataArr.forEach(banco => {
      this.addBankGroup(banco);
    });
  }

  getPayoutDetails(payoutProcessId: string, customerProcessId: string) {
    this.getPayoutDetails$ = this.payoutService.getPayoutProcessDetails(payoutProcessId)
      .pipe(
        takeUntil(this.destroy$),
        tap(payout => {
          this.name = payout.name;
          this.isConfirmButtonActive = payout.status !== 'PROCESSING';
        }),
        switchMap(payout => {
          return this.payoutMasiveConfirmService.getPayoutsToConfirmList(customerProcessId, payoutProcessId)
          .pipe(
            tap((payoutList => {
              this.buildCustomConfirmForm(payoutList);
              this.spinnerService.hide();
            })),
            catchError(error => {
              this.spinnerService.hide();
              console.error('Error! While trying to get the payout list', error)
              return of(null);
            })
          )
        }),
        catchError(error => {
          this.spinnerService.hide();
          console.error("Failed! while trying to bring payout's detail " + error.error)
          return of(null);
        })
      )
      .subscribe()
  }

  setAlert(status: string) {
    const statusSelected = this.statusMap[status];
    if (statusSelected !== undefined) {
      this.confirmMessage = statusSelected;
      this.openModal(this.modalConfirmationMessage);
    }
  }

  executeGetPayoutProcessDetails() {
    this.timerId = setTimeout(() => {
      this.getPayoutProcessDetailsAfterConfirm();
    }, 10000);
  }

  processDataToConfirm(form: { name: string, label: string, url: string, psp: string, pspValue: string }[]): PayloadPayoutToConfirm {
    const newData: PayloadPayoutToConfirm = {
      file_list: [],
      operations: {}
    };

    form.forEach((item: { [x: string]: string; name: string; url: string; label: string; pspValue: string; }) => {
      let { name, label, url, psp, pspValue } = item;
      name = label != undefined && label.trim().length > 0 ? label : name;
      const new_item = { name, url };
      newData.file_list.push(new_item);
      newData.operations[psp] = pspValue;
    });

    return newData;
  }

  confirm(confirmForm: FormGroup) {
    clearTimeout(this.timerId);

    this.spinnerService.show();

    this.formData = new FormData();
    const formValue = confirmForm.value.file_list;
    const newData = this.processDataToConfirm(formValue);
    const metadata = JSON.stringify(newData, null);
    this.formData.append('metadata', metadata);
    this.payoutService.confirmOperations(this.payoutProcessId, this.formData)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.isConfirmButtonActive = true;
        this.executeGetPayoutProcessDetails();

      }, error => {
        this.spinnerService.hide();
        this.executeGetPayoutProcessDetails();
        console.error('Failed! while trying to confirm the payout' + error.error);
      })
  }

  getPayoutProcessDetailsAfterConfirm() {
    this.getPayoutStatus$ = this.payoutService.getPayoutProcessDetails(this.payoutProcessId)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: data => {
          this.isConfirmButtonActive = data.status !== 'PROCESSING';
          this.setAlert(data.status);
          this.spinnerService.hide();
        },
        error: err => {
          this.spinnerService.hide();
          console.error("Failed! while trying to bring payout's status " + err.error)
        }
      })
  }

  onOptionChange(event: Event, index: number) {
    const selectElement = event.target as HTMLSelectElement;
    const dataId = selectElement.options[selectElement.selectedIndex].getAttribute('data-id');
    const formGroupAtIndex = this.file_list.at(index) as FormGroup;
    formGroupAtIndex.get('psp').setValue(dataId);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered' });
  }

  hideModal(): void {
    this.modalRef.hide();
    this.router.navigate(['/payout_process_commerce/list']);
  }

  ngOnDestroy() {
    clearTimeout(this.timerId);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
